module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-2_active-56601c3152953d87ee0843012949f547.svg";